import { useEffect, useRef, useState } from "react";

export default function Pagination({
  currentPage = 1,
  recordsPerPage = 10,
  setRecordsPerPage,
  onPrevious,
  onNext,
  totalRecord,
  title = "record",
  handleGoto,
  className = "bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 overflow-hidden mt-4 py-2 px-2 mr-12",
}) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(currentPage);
  const inputRef = useRef(null);

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
      inputRef.current?.select();
      setValue(currentPage)
    }
  }, [editing]);



  const startIndex = (currentPage - 1) * recordsPerPage + 1;
  const endIndex = Math.min(currentPage * recordsPerPage, totalRecord || 0);
  const totalPage = Math.ceil(totalRecord / recordsPerPage);

  const handleChange = (e) => {
    let val = e.target.value.replace(/[^0-9]/g, "");

    if (val && Number(val) < 1) {
      val = 1;
    } else if (Number(val) > totalPage) {
      val = totalPage;
    }

    setValue(Number(val));
  };
  const handleblur = () => {
  
    setEditing(false);
    if ((currentPage !== value ) && (value)) {
      handleGoto?.(value);
    }
  };
  const handlePageSize = (size)=>{
setRecordsPerPage(size);
  }
  return (
    <div className={className}>
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
          <span>Show</span>
          <select
            value={recordsPerPage}
            disabled={!totalRecord}
            onChange={(e) => handlePageSize(Number(e.target.value))}
            className="px-3 py-1.5 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={20}>20</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>

          <span>entries</span>
        </div>

        {/* Pagination Controls */}
        <div className="flex items-center gap-1 mr-4">
          <button
            onClick={() => onPrevious(currentPage - 1)}
            disabled={(currentPage === 1) || !totalRecord}
            className="px-3 py-1 text-sm border border-slate-300 dark:border-slate-700 rounded hover:bg-slate-100 dark:hover:bg-slate-800 disabled:opacity-50"
          >
            Previous
          </button>

          {/* Current Page */}
          <div className="flex items-center gap-1 mx-2">
            <>
              {!editing ? (
                <button
                  disabled={!handleGoto ||  !totalRecord}
                  onClick={() => setEditing(true)}
                  className="px-3 py-1 text-sm bg-[#0072FF] text-white rounded"
                >
                  {currentPage}
                </button>
              ) : (
                <input
                  ref={inputRef}
                  value={value}
                  onChange={handleChange}
                  onBlur={handleblur}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleblur();
                    }
                  }}
                  className="px-3 py-1 w-14 d text-sm font-medium text-center border border-[#0072FF] rounded outline-none"
                />
              )}
            </>
          </div>

          <button
            onClick={() => onNext(currentPage + 1)}
            disabled={(currentPage === totalPage) || !totalRecord}
            className="px-3 py-1 text-sm border border-slate-300 dark:border-slate-700 rounded hover:bg-slate-100 dark:hover:bg-slate-800 disabled:opacity-50"
          >
            Next
          </button>
        </div>

        <div className="text-sm text-slate-500 dark:text-slate-400 mt-0.5 ">
          Showing {totalRecord?(startIndex || 0):0} – {endIndex || 0} of {totalRecord || 0}{" "}
          {title}
        </div>
      </div>
    </div>
  );
}
